<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <cadri-data-table
              v-if="nmInterface"
              ref="jtDataTable"
              class="table-crud"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              singleselect
              :row-buttons="rowButtons"
              @selection="selection"
              @action-button="actionButton"
              @show-message="showMessage"
            />
          </q-card-section>
          <q-card-section>
            <jt-data-grid-subtitle :subtitles="subtitles" />
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import CadriDataTable from './CadriDataTable'
import JtDataGridSubtitle from '../../../components/jt-data-grid-subtitle/JtDataGridSubtitle'
const { pageTable } = JtCrud

@Component({
  mixins: [pageTable],
  name: 'CadriPageTable',
  components: { CadriDataTable, JtDataGridSubtitle }
})
class CadriPageTable extends Vue {
  subtitles = [
    {
      name: 'CADRI_S_EXPIRATION',
      colSize: 8,
      options: [
        {
          name: 'CADRI_S_EXPIRATION_EXPIRED',
          classLegendColor: 'red-legend'
        },
        {
          name: 'CADRI_S_EXPIRATION_EXPIRATION_IN_30_DAYS',
          classLegendColor: 'yellow-legend'
        },
        {
          name: 'CADRI_S_EXPIRATION_EXPIRATION_IN_60_DAYS',
          classLegendColor: 'blue-legend'
        },
        {
          name: 'Parcialmente ativo',
          classLegendColor: 'orange-legend'
        }
      ]
    },
    {
      name: 'CADRI_REMANING_IN_PERCENT',
      colSize: 8,
      options: [
        {
          name: 'CADRI_REMANING_IN_PERCENT_0',
          classLegendColor: 'red-legend'
        },
        {
          name: 'CADRI_REMANING_IN_PERCENT_10',
          classLegendColor: 'yellow-legend'
        },
        {
          name: 'CADRI_REMANING_IN_PERCENT_30',
          classLegendColor: 'blue-legend'
        }
      ]
    }
  ];
}
export default CadriPageTable
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
